<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <h2 class="footer-title">Contact US</h2>
      <div class="footer-email">support@fun2ever.com</div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
};
</script>

<style lang="less" scoped>
@import url('../assets/style/colors.less');

.site-footer {
  width: 100%;
  margin-top: auto;
  padding: 2.5rem 2rem 3rem;
  background-color: @lanmu_no;
  box-sizing: border-box;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(229, 202, 137, 0.55) 50%,
      transparent 100%
    );
  }
}

.footer-inner {
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
}

.footer-title {
  margin: 0 0 0.75rem;
  font-size: clamp(14px, 1.1vw, 18px);
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #e5ca8a;
}

.footer-email {
  display: inline-block;
  font-size: clamp(13px, 1vw, 16px);
  font-weight: 500;
  letter-spacing: 0.04em;
  color: @font_color;
  text-decoration: none;
  transition: color 0.25s ease, opacity 0.25s ease;

  &:hover {
    color: #e5ca8a;
    opacity: 0.92;
  }

  &:focus-visible {
    outline: 1px solid #cba24c;
    outline-offset: 4px;
  }
}

@media screen and (max-width: 992px) {
  .site-footer {
    padding: 2rem 1.25rem 2.5rem;
  }

  .footer-title {
    letter-spacing: 0.15em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue